module.exports = __webpack_public_path__ + "img/ep6-9.e7c0c386.png";